import './CreateEditDialog.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import ToastContext from '../../../../../context/ToastContext';
import useAxios from '../../../../../hooks/useAxios';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import {
  FormDataFranchise,
  FranchiseType,
} from '../../../../../types/api/franchises';
import {
  errorToast,
  successToast,
} from '../../../../../utils/helpers/primereact';
import { toApiData } from './CreateEditDialog.functions';
import FormContainer from './FormContainer';

type Props = {
  visible: boolean;
  onHide: () => void;
  data: FranchiseType | undefined;
  isLoading: boolean;
  isEditDialog: boolean;
  reloadFranchises: () => void;
};

function CreateEditDialog({
  visible,
  onHide,
  isEditDialog,
  data,
  reloadFranchises,
}: Props) {
  const { t } = useTranslation();
  const { toastRef } = useContext(ToastContext);

  const { reload: formSubmitRequest, isLoading: isFormSubmitRequestLoading } =
    useAxios();

  function handleSubmitForm(values: FormDataFranchise) {
    console.log('values', values);
    if (isEditDialog) {
      formSubmitRequest({
        url: `/v2/franchises/${data?.id}`,
        payload: toApiData(values),
        method: 'PUT',
        successCallback: () => {
          successToast(
            toastRef,
            t('Success'),
            t('Franchise {{name}} has been edited successfully', {
              name: values.name,
            })
          );
          reloadFranchises();
          onHide();
        },
        errorCallback: (err: any) => {
          if (err) {
            errorToast(toastRef, t('Error'), t('An error occured ', err));
            return;
          }
        },
      });
    } else {
      formSubmitRequest({
        url: '/v2/franchises',
        payload: toApiData(values),
        method: 'POST',
        successCallback: () => {
          successToast(
            toastRef,
            t('Success'),
            t('Franchise {{name}} has been created successfully', {
              name: values.name,
            })
          );
          reloadFranchises();
          onHide();
        },
        errorCallback: (err: any) => {
          console.log('err ', err);

          if (err) {
            errorToast(toastRef, t('Error'), t('An error occured ', err));
            return;
          }
        },
      });
    }
  }

  const dialogHeader = isEditDialog ? data?.name : t('Add new franchise');

  const dialogFooter = (
    <div>
      <Button
        type="button"
        label={t('Cancel')}
        className="p-button-secondary p-button-text"
        onClick={() => onHide()}
      />

      <Button
        type="submit"
        form="franchise-create-edit-form"
        label={
          isFormSubmitRequestLoading
            ? t('Saving...')
            : isEditDialog
            ? t('Save changes')
            : t('Create')
        }
        disabled={isFormSubmitRequestLoading}
        className="p-button-primary"
        data-cy="submit"
      />
    </div>
  );

  const isOnMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={dialogHeader}
      footer={dialogFooter}
      blockScroll
      resizable={false}
      maximizable
      maximized={isOnMobile}
      className="franchises-create-edit-dialog"
    >
      <FormContainer
        isEditDialog={isEditDialog}
        handleSubmitForm={handleSubmitForm}
        data={data}
      />
    </Dialog>
  );
}

export default CreateEditDialog;
